<template>
  <dialog id="dialog">
    <div class="dialog-content">
      <button @click="hideModal()">
        <Icon icon="material-symbols-light:close" />
      </button>
      <img :src="currentImage.url"/>
      <p>{{ currentImage.title }}</p>
      <p>{{ currentImage.type }}</p>
    </div>
  </dialog>
  <div class="about">
    <h2>Selected Works</h2>
    <div class="images">
      <div class="image" v-for="image in images" v-bind:key="image.url" @click="showModal(image)">
        <div class="image-container">
          <img :src="image.url"/>
        </div>
        <p>{{ image.title }}</p>
        <p>{{ image.type }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Icon } from '@iconify/vue'

interface ArtWork {
    url: string;
    title: string;
    type: string;
}

export default defineComponent({
  name: 'HomeView',
  components: {
    Icon
  },
  data () {
    return {
      currentImage: {},
      images: [
        { url: 'https://malikblackman.com/images/1.png', title: 'Interconnectedness', type: 'Acrylic on canvas, 3x5 ft' },
        { url: 'https://malikblackman.com/images/2.png', title: 'B.A.A (biblically accurate angels)', type: 'Acrylic on canvas, 3.5x3.5 ft' },
        { url: 'https://malikblackman.com/images/3.png', title: 'Seeing Red', type: 'Marker on drawing paper, 3x3 ft' },
        { url: 'https://malikblackman.com/images/4.png', title: 'Continuum', type: 'Gel pen on drawing paper, 8.5x11 in' },
        { url: 'https://malikblackman.com/images/5.png', title: 'Pupil', type: 'Gel pen on drawing paper, 8.5x11 in' },
        { url: 'https://malikblackman.com/images/6.png', title: 'Untitled', type: 'Gel pen on drawing paper, 8.5x11 in' }
      ]
    }
  },
  methods: {
    showModal (image: ArtWork) {
      this.currentImage = image
      const dialog = document.getElementById('dialog') as any
      dialog.showModal()
    },

    hideModal () {
      const dialog = document.getElementById('dialog') as any
      dialog!.close()
      this.currentImage = {}
    }
  }
})
</script>

<style lang="scss">
body:has(dialog[open]) {
  overflow: hidden;
}

.images {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;

  .image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  p {
    margin: 0;
    font-family: "Times New Roman", Times, serif;
    font-style: italic;
  }

  .image-container {
    display: inline-block;
    position: relative;
  }

  .image-container:after {
    content:'\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #774936;
    opacity: 0;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
  }

  .image-container:hover:after {
     opacity: 0.6;
  }
}

.images > div img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}

dialog {
 width: 70vw;
 height: 90vh;
 border: none;

 .dialog-content {
   display: grid;
   grid-template-rows: min-content 1fr min-content min-content;
   width: 100%;
   height: 100%;

  img {
     width: 100%;
     height: 100%;
     min-height: 0;
     object-fit: contain;
   }

  p {
    margin: 0;
    font-family: "Times New Roman", Times, serif;
    font-style: italic;
  }

  button {
    border: none;
    background: none;
    width: fit-content;
    justify-self: end;
    font-size: 3rem;
  }
 }
}
dialog::backdrop {
  backdrop-filter: blur(5px);
}
</style>
